module.exports = require("@splunk/dashboard-visualizations/MarkerGauge");